<div class="dl-breadcrumbs">
    <span class="dl-breadcrumbs__path"
          *ngFor="let item of directoryPathState | async"
          [class.active]="item.activatedPath"
          (click)="returnToDirectory(item.route)"
    >
        {{item.route.name + ' /'}}
    </span>
</div>
